import React from 'react'
import styled from 'styled-components'
import { Box } from 'pcln-design-system'
import PropTypes from 'prop-types'
import { WidthSkeleton } from './WidthSkeleton'

const Wrapper = styled(Box)`
  ${(props) => props.height && `height: ${props.height};`}
`

const SkeletonBox = ({ height, width, mr, ml, mb, mt }) => (
  <Wrapper height={height} width={width} mr={mr} ml={ml} mb={mb} mt={mt}>
    <WidthSkeleton width='100%' height={height} />
  </Wrapper>
)

SkeletonBox.propTypes = {
  height: PropTypes.array,
  width: PropTypes.array,
  mr: PropTypes.array,
  ml: PropTypes.array,
  mb: PropTypes.array,
  mt: PropTypes.array,
}

export default SkeletonBox
